import service from "@/services/types/cabys";

export const namespaced = true;

export const state = () => ({
  list: [],
});

export const mutations = {
  LIST: (state, objs) => (state.list = objs),
};

export const actions = {
  // list: ({ commit }, value) => (state.list?.length ? state.list : service.list(value).then(result => commit('LIST', result) || result))
  readByDescription: ({ commit }, input) =>
    service.readByDescription(input).then((result) => {
      commit("LIST", result);
      return result;
    }),
};
